import { BasicResponseDTO } from "@dto/basicResponse.dto";
import { Button, Checkbox, Form, Input } from "antd";
import { AxiosError } from "axios";
import { FC, useState } from "react";
import { XmSpinner } from "src/component/spinner/XmSpinner";
import { Log } from "src/service/log.service";
import { getSQLLogs } from "../api/LogExporterAPI";

interface iFormValues {
  sql: string;
  compact: boolean;
}
interface SQLError extends Error {
  location: {
    start: {
      line: number;
      column: number;
    };
    end?: {
      line: number;
      column: number;
    };
  };
}

const LogExporterForm: FC = () => {
  const [formSQL] = Form.useForm<iFormValues>();
  const [isLoading, setIsLoading] = useState(false);
  const [hasSyntaxError, setHasSyntaxError] = useState(false);

  const setSQLError = (error: SQLError) => {
    formSQL.setFields([{
      name: "sql",
      errors: [`Provided SQL is invalid please check if you copied the SQL statement correctly. Syntax error at line ${error.location.start.line} and column ${error.location.start.column}`]
    }]);
    setHasSyntaxError(true);
    Log.error("SQL Syntax Error", error);
  };

  const processFileDownload = (data: Blob) => {
    const href = window.URL.createObjectURL(data);

    const anchorElement = document.createElement('a');

    anchorElement.href = href;
    anchorElement.download = "logs.tar.gz";

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
  };

  const submitSQLExport = async (values: iFormValues) => {

    setIsLoading(true);
    setHasSyntaxError(false);

    formSQL.setFields([{
      name: "sql",
      errors: [``]
    }]);

    try {
      if (values.sql) {
        const { Parser } = await import("node-sql-parser/build/postgresql");
        const parser = new Parser();
        parser.astify(values.sql);
      }

      const data: Blob = await getSQLLogs({ sql: values.sql, compact: values.compact });
      processFileDownload(data);

    } catch (error) {
      const axiosError = AxiosError<BasicResponseDTO>;
      console.error(axiosError);
      if (axiosError.name === "SyntaxError") {
        setSQLError(error as SQLError);
      }
    }

    setIsLoading(false);

  };

  return (
    <div>
      <Form
        form={formSQL}
        onFinish={submitSQLExport}
        style={{
          position: "relative"
        }}
      >
        <Form.Item
          name="sql"
        >
          <Input.TextArea
            rows={10}
            cols={50}
            placeholder="Enter SQL provided by support team. This can be left Empty"
            disabled={isLoading}
            style={hasSyntaxError ? { outline: "solid red 1px" } : {}}
          />
        </Form.Item>
        <Form.Item
          name="compact"
          valuePropName="checked"
        >
          <Checkbox
            disabled={isLoading}
          >
            Compact
          </Checkbox>
        </Form.Item>
        <Button
          disabled={isLoading}
          type="primary"
          htmlType="submit"
        >
          Export All Logs
        </Button>
        {
          isLoading && <XmSpinner />
        }
      </Form>
    </div>
  );
};

export default LogExporterForm;